export default __webpack_public_path__ + "static/media/img-logo-cloud-google.b87a77f9.svg";